import LocationSideBar from './LocationSideBar.view';

export default LocationSideBar;
